import Cnpj from './fields/Cnpj'
import Default from './fields/Default'
import Phone from './fields/Phone'

export default {
  Cnpj,
  Default,
  Phone
}
